import { apiSlice } from '../api/apiSlice';
import { SupportTicketParams, SupportTicketResponse } from './supportApiTypes';

export const supportApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createSupportTicket: builder.mutation<
            SupportTicketResponse,
            SupportTicketParams
        >({
            query: (ticketData) => ({
                url: '/tickets',
                method: 'POST',
                body: ticketData,
            }),
            invalidatesTags: ['supportTickets'],
        }),
    }),
});

export const { useCreateSupportTicketMutation } = supportApiSlice;
